// @flow

type Test = {
  id: string,
  name: string,
  scope: string,
  location: string,
  url: string,
  average_duration: string,
  reliability: string,
};

type Props = {
  test: Test,
};

const Row = (props: Props) => (
  <li className="col-12 p1 row-link__container">
    <div className="ta-suite-card ta-card__container--body">
      <div className="main-section">
        <a
          href={props.test.url}
          className="block text-decoration-none color-inherit row-link"
        >
          <span className="semi-bold block">
            {props.test.scope} {props.test.name}
          </span>
        </a>
        <span className="mt1 small dark-gray block">{props.test.location}</span>
      </div>
      <div className="secondary-section">
        <div className="pr3 right-align" style={{ width: "100px" }}>
          {props.test.reliability}
          <span className="hide"> reliable</span>
        </div>
        <div className="right-align" style={{ width: "118px" }}>
          {props.test.average_duration}
          <span className="hide"> average duration</span>
        </div>
      </div>
    </div>
  </li>
);

export default Row;
